import { useMutation } from '@tanstack/react-query';
import { toast } from '@huspy/forge/shared';
import { useTranslation } from 'react-i18next';
import { coreApi } from '../../api';
import { UpdateBrokerAccount } from '../../api/types';

const useUpdateBroker = () => {
  const { t } = useTranslation();

  const {
    error, mutate, isPending, mutateAsync,
  } = useMutation({
    mutationKey: ['brokerUpdate'],
    mutationFn: (body: UpdateBrokerAccount & { userId: string }) =>
      coreApi.updateBroker(body.userId, { phone_number: body.phone_number }),
    onSuccess: (_) => {
      toast('info', { message: t('account.updatedSuccess') });
    },
    onError: (mutationError) => {
      toast('error', {
        message: mutationError.data?.phone_number?.[0]
        ?? mutationError.message
        ?? t('account.updatedFail'),
      });
    },
  });

  return {
    mutate, error, isPending, mutateAsync,
  };
};

export default useUpdateBroker;
